import styles from "./LeftPanelBar.module.scss";
import logo from "../../assets/images/logo.svg";
import { ServerStatus } from "../../shared/ServerStatus/ServerStatus";
import { TemplateButton } from "../Template/TemplateButton/TemplateButton";
import { InformationIcon } from "../../assets/svg/InformationIcon";
import { HistoryButton } from "../History/components/HistoryButton/HistoryButton";
import { LogoutButton } from "./components/LogoutButton/LogoutButton";
import {
  redoAction,
  undoAction,
} from "../../redux/reducers/ui/actions/actions";
import { toggleSceneHint } from "../../redux/reducers/app/appReducer";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { getSceneHintState } from "../../redux/reducers/app/appSelectors";
import clsx from "clsx";
import ResetScene from "../../assets/svg/ResetScene";
// (scene reset is handled inside ResetSceneModal)
import { changeShowModal } from "../../redux/reducers/app/appReducer";

export const LeftPanelBar = () => {
  const isSceneHint = useAppSelector(getSceneHintState());
  const dispatch = useAppDispatch();

  console.log("isSceneHint", isSceneHint);

  const undo = () => {
    dispatch(undoAction());
  };

  const redo = () => {
    dispatch(redoAction());
  };

  const openResetSceneModal = () => {
    dispatch(changeShowModal({ nameModal: "resetScene", stateModal: true }));
  };

  const handleInformationClick = () => {
    dispatch(toggleSceneHint());
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.logo}>
          <img src={logo} alt="logo" />
        </div>
        <ServerStatus />
      </div>
      <div className={styles.footer} data-tour="left-panel">
        <div className={styles.group}>
          <TemplateButton />
          <HistoryButton />
        </div>
        <div className={styles.group}>
          <button onClick={openResetSceneModal} data-tour="reset-scene-btn">
            <ResetScene />
          </button>
        </div>
        <div className={styles.group}>
          <button
            type="button"
            onClick={handleInformationClick}
            className={clsx({ [styles.active_btn]: isSceneHint.isShow })}
            data-tour="control-sett-btn"
          >
            <InformationIcon />
          </button>
          <LogoutButton />
        </div>
      </div>
    </div>
  );
};
